import { render, staticRenderFns } from "./NftManagerDetails.vue?vue&type=template&id=ce218c08&scoped=true"
import script from "./NftManagerDetails.vue?vue&type=script&lang=js"
export * from "./NftManagerDetails.vue?vue&type=script&lang=js"
import style0 from "./NftManagerDetails.vue?vue&type=style&index=0&id=ce218c08&prod&lang=scss&scoped=true"
import style1 from "./NftManagerDetails.vue?vue&type=style&index=1&id=ce218c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce218c08",
  null
  
)

export default component.exports